module.exports = __webpack_public_path__ + "media/multiop.37e304a7.mp4";